import { Form, Formik } from 'formik';
import * as Yup from "yup";
import { Box } from '@mui/material';
import { ROLES } from '../../utils/appRoles';
import axios from '../../utils/axios';
import FormGroup from '../shared/containers/FormGroup';
import Input from '../shared/formInput/Input';
import SelectInput from '../shared/formInput/SelectInput';
import PrimaryButton from '../shared/buttons/PrimaryButton';
import {useNotifications} from 'reapop';

const CreateUserForm = ({submitButtonChildren, submitUrl}) => {
    const {notify} = useNotifications();
    const initialValues = {
        first_name: '',
        last_name: '',
        email: '',
        phone_number: '',
        // password: '',
        type: '',
        title: '',
    };

    const onSubmit = async (values, {resetForm, setErrors, setSubmitting}) => {
        try {
            await axios.post(submitUrl, values);
            resetForm();
            notify('Utilisateur créé avec succès', 'info', {dismissAfter: 5000}); 
        } catch (error) {
            setErrors({createError: error.message})
            // console.error(error)
        }
    };

    const validationSchema = Yup.object({
        email: Yup.string()
            .required("champ requis")
            .email("format: utilisateur@domaine.fr"),
        // password: Yup.string()
        //     .required("champ requis")
        //     .trim("Sans d'espace")
        //     .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\da-zA-Z]).{8,}$/, { message: "min(8) Maj Minus special", excludeEmptyString: true })
        //     .strict(),
        first_name: Yup.string()
            .required("champ requis"),
        type: Yup.string()
            .required("champ requis"),
        last_name: Yup.string()
            .required("champ requis"),
        phone_number: Yup.string()
            .matches(/^\d{10}$/, { message: "format: 0655443322", excludeEmptyString: true })
            // .required("champ requis"),
    });

    const formStyle = {
        width: "fit-content",
        margin: "2em auto 0"
    };

    return (
        <Formik {...{ initialValues, onSubmit, validationSchema }}>
            {({errors, isValid, dirty}) => (
                <Box sx={formStyle}>
                    {errors.createError && <p>{errors.createError}</p>}
                    <Form autoComplete="off">
                        <FormGroup multi>
                            <Input
                                {...{
                                    name: "first_name",
                                    label: "Prénom",
                                }}
                            />
                            <Input
                                {...{
                                    name: "last_name",
                                    label: "Nom",
                                }}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Input
                                {...{
                                    name: "email",
                                    label: "Email",
                                }}
                            />
                        </FormGroup>
                        {/* <FormGroup>
                            <Input 
                                {...{
                                    name: "password",
                                    label: "Mot de passe",
                                    helperText: "min(8) Maj Minus special(●!\"#$%&'()*+-./:?@^_`{}~)"
                                }}
                            />
                        </FormGroup> */}
                        <FormGroup>
                            <Input 
                                {...{
                                    name: "phone_number",
                                    label: "Téléphone",
                                    required: false,
                                    helperText: "format: 0655443322"
                                }}
                            />
                        </FormGroup>
                        <FormGroup>
                            <SelectInput {...{
                                name: "type",
                                label: "Rôle",
                                options: ROLES,
                            }}/>
                        </FormGroup>
                        <FormGroup>
                            <Input 
                                {...{
                                    name: "title",
                                    label: "Poste",
                                    required: false
                                }}
                            />
                        </FormGroup>
                        <PrimaryButton type="submit" disabled={!isValid || !dirty}>
                            {submitButtonChildren}
                        </PrimaryButton>
                    </Form>
                </Box>
            )}
        </Formik>
    );
}

export default CreateUserForm;
